import React, { useContext } from 'react';
import First from './First';
import Second from './Second';
import Third from './Third';
import Nav from '../Nav';
import { GlobalContext } from 'App';
import SecondMo from './SecondMo';

const Program = () => {
    const { isTablet } = useContext(GlobalContext);
    return (
        <section id="employed_program">
            <First />
            {
                !isTablet &&
                <Nav />
            }
            {
                isTablet ?
                    <SecondMo /> :
                    <Second />
            }
            <Third />
        </section>
    );
}

export default Program;

